// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_al0","cls2":"OnboardingTour-cls2_82a OnboardingTour-cls1_al0"};